module.exports = __webpack_public_path__ + "img/iconfont.97629929.svg";